<template>
  <p class="text-overline mb-1" style="color:var(--c-brand);letter-spacing:2px;">{{ auth.brokerageName }}</p>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useAuthStore } from '@/stores/auth';

/** Page overline showing the name of the brokerage the user is signed in to. */
export default defineComponent({
  name: 'BrokerageOverline',
  setup() {
    return { auth: useAuthStore() };
  },
});
</script>
